/**
 * Return `true` if the type of `x` is `unknown[]`.
 *
 * Use {@linkcode [is/arrayt-of].isArrayOf|isArrayOf} to check if the type of `x` is an array of `T`.
 *
 * ```ts
 * import { is } from "@core/unknownutil";
 *
 * const a: unknown = [0, 1, 2];
 * if (is.Array(a)) {
 *   const _: unknown[] = a;
 * }
 * ```
 */
export function isArray(
  x: unknown,
): x is unknown[] {
  return Array.isArray(x);
}

// denoCacheMetadata={"headers":{"last-modified":"Sat, 24 Aug 2024 00:09:45 GMT","server":"UploadServer","expires":"Sat, 08 Nov 2025 10:08:30 GMT","x-goog-stored-content-encoding":"identity","x-goog-stored-content-length":"407","cache-control":"public, max-age=31536000, immutable","age":"91","content-type":"text/typescript","x-jsr-cache-id":"IAD","x-goog-storage-class":"STANDARD","access-control-expose-headers":"*","cross-origin-resource-policy":"cross-origin","x-content-type-options":"nosniff","alt-svc":"h3=\":443\"; ma=2592000,h3-29=\":443\"; ma=2592000","content-security-policy":"default-src 'none'; script-src 'none'; style-src 'none'; img-src 'none'; font-src 'none'; connect-src 'none'; frame-src 'none'; object-src 'none'; frame-ancestors 'none'; sandbox; form-action 'none';","x-guploader-uploadid":"AHmUCY04awSGgf6dawyS5rhnH9Cezl0ptbUfLQ1fY9Unucl2ozfxmfd1D4jORA6cFjOUoGNhe3SJd3zJRw","x-goog-hash":"crc32c=NIigqg==,md5=NyXtXI6GvClAdBOvx+B1wQ==","date":"Fri, 08 Nov 2024 10:08:30 GMT","x-jsr-cache-status":"hit","x-robots-tag":"noindex","access-control-allow-origin":"*","x-goog-generation":"1724458185502412","etag":"\"3725ed5c8e86bc29407413afc7e075c1\"","accept-ranges":"bytes","x-goog-metageneration":"1","content-length":"407","via":"1.1 google"},"url":"https://jsr.io/@core/unknownutil/4.3.0/is/array.ts","time":1731060600}